var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-information field-spacing-container" },
    [
      _c(
        "form-wrapper",
        { staticClass: "form-wrapper", attrs: { validator: _vm.$v.member } },
        [
          _c("div", { staticClass: "information-box" }, [
            _c("div", { staticClass: "md-layout" }, [
              _c(
                "div",
                { staticClass: "md-layout-item" },
                [
                  _c(
                    "form-group",
                    { attrs: { name: "memberCode", label: "Code" } },
                    [
                      _c("md-input", {
                        attrs: { disabled: !_vm.isAllowedToUpdate },
                        model: {
                          value: _vm.member.memberCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.member, "memberCode", $$v)
                          },
                          expression: "member.memberCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "md-layout-item" },
                [
                  _c(
                    "form-group",
                    { attrs: { name: "firstName", label: "First Name" } },
                    [
                      _c("md-input", {
                        attrs: { disabled: !_vm.isAllowedToUpdate },
                        model: {
                          value: _vm.member.firstName,
                          callback: function ($$v) {
                            _vm.$set(_vm.member, "firstName", $$v)
                          },
                          expression: "member.firstName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "md-layout-item" },
                [
                  _c(
                    "form-group",
                    { attrs: { name: "lastName", label: "Last Name" } },
                    [
                      _c("md-input", {
                        attrs: { disabled: !_vm.isAllowedToUpdate },
                        model: {
                          value: _vm.member.lastName,
                          callback: function ($$v) {
                            _vm.$set(_vm.member, "lastName", $$v)
                          },
                          expression: "member.lastName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "md-layout" }, [
              _c(
                "div",
                { staticClass: "md-layout-item" },
                [
                  _c(
                    "form-group",
                    { attrs: { name: "email", label: "Email Address" } },
                    [
                      _c("md-input", {
                        model: {
                          value: _vm.member.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.member, "email", $$v)
                          },
                          expression: "member.email",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "md-layout-item" },
                [
                  _c(
                    "form-group",
                    { attrs: { name: "phone", label: "Phone" } },
                    [
                      _c("md-input", {
                        attrs: { disabled: !_vm.isAllowedToUpdate },
                        model: {
                          value: _vm.member.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.member, "phone", $$v)
                          },
                          expression: "member.phone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm.skillList.length
            ? _c("div", { staticClass: "information-box" }, [
                _c("div", { staticClass: "md-layout" }, [
                  _c("div", { staticClass: "md-layout-item" }, [
                    _c(
                      "div",
                      { staticClass: "skillfield-container" },
                      [
                        _vm.member.skills.length
                          ? _c("label", { attrs: { for: "skills" } }, [
                              _vm._v("Skills"),
                            ])
                          : _vm._e(),
                        _c("multiselect", {
                          attrs: {
                            options: _vm.skillList,
                            multiple: true,
                            "close-on-select": true,
                            disabled: !_vm.isAllowedToUpdate,
                            placeholder: "Pick skills",
                          },
                          model: {
                            value: _vm.member.skills,
                            callback: function ($$v) {
                              _vm.$set(_vm.member, "skills", $$v)
                            },
                            expression: "member.skills",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "information-box" }, [
            _c("div", { staticClass: "md-layout" }, [
              _c("div", { staticClass: "md-layout-item" }, [
                _c(
                  "div",
                  { staticClass: "skillfield-container" },
                  [
                    _c("label", { attrs: { for: "serviceAreas" } }, [
                      _vm._v("Service Areas"),
                    ]),
                    _c("multiselect", {
                      attrs: {
                        options: _vm.serviceAreasList,
                        multiple: true,
                        "close-on-select": true,
                        placeholder: "Pick service areas",
                      },
                      model: {
                        value: _vm.member.serviceAreas,
                        callback: function ($$v) {
                          _vm.$set(_vm.member, "serviceAreas", $$v)
                        },
                        expression: "member.serviceAreas",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm.capacityDefinitions.length
            ? _c("div", { staticClass: "information-box" }, [
                _c("div", { staticClass: "md-layout" }, [
                  _c(
                    "div",
                    { staticClass: "md-layout-item" },
                    _vm._l(_vm.capacityDefinitions, function (capacity, index) {
                      return _c("capacity-inputs", {
                        key: index,
                        attrs: {
                          "capacity-definition": capacity,
                          "initial-value": _vm.capacityValues[capacity.type],
                          disabled: !_vm.isAllowedToUpdate,
                        },
                        on: { changed: _vm.handleCapacityChanged },
                      })
                    }),
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "information-box" }, [
            _c(
              "div",
              { staticClass: "md-layout-item md-xsmall-size-100 md-size-34" },
              [
                _c(
                  "form-group",
                  {
                    attrs: {
                      name: "emissionPerDistance",
                      label: "C02 per km/mile",
                    },
                  },
                  [
                    _c("md-input", {
                      attrs: { type: "number" },
                      model: {
                        value: _vm.member.emissionPerDistance,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.member,
                            "emissionPerDistance",
                            _vm._n($$v)
                          )
                        },
                        expression: "member.emissionPerDistance",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "information-box" }, [
            _c("div", { staticClass: "md-layout" }, [
              _vm.showTeamRegion
                ? _c(
                    "div",
                    { staticClass: "md-layout-item" },
                    [
                      _c(
                        "form-group",
                        {
                          attrs: { name: "team-region", label: "Team Region" },
                        },
                        [
                          _c("team-region-options", {
                            attrs: {
                              mode: "update",
                              selected: _vm.member.teamRegionId,
                              "show-auto": false,
                              enabled:
                                _vm.canEditOwnTeamRegion &&
                                _vm.isAllowedToUpdate,
                            },
                            on: { selectedOption: _vm.handleTeamRegionChanged },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "information-box" }, [
            !_vm.hasTeam
              ? _c("div", { staticClass: "md-layout" }, [
                  _c(
                    "div",
                    { staticClass: "md-layout-item" },
                    [
                      _c(
                        "form-group",
                        { attrs: { name: "company", label: "Company" } },
                        [
                          _c("md-input", {
                            attrs: { disabled: !_vm.isAllowedToUpdate },
                            model: {
                              value: _vm.member.company,
                              callback: function ($$v) {
                                _vm.$set(_vm.member, "company", $$v)
                              },
                              expression: "member.company",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "md-layout-item" },
                    [
                      _c(
                        "form-group",
                        { attrs: { name: "industry", label: "Industry" } },
                        [
                          _c("md-input", {
                            attrs: { disabled: !_vm.isAllowedToUpdate },
                            model: {
                              value: _vm.member.industry,
                              callback: function ($$v) {
                                _vm.$set(_vm.member, "industry", $$v)
                              },
                              expression: "member.industry",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _c("div", { staticClass: "md-layout" }, [
              _c(
                "div",
                { staticClass: "md-layout-item" },
                [
                  _c(
                    "form-group",
                    { attrs: { name: "role", label: "Team Role" } },
                    [
                      _c(
                        "md-select",
                        {
                          attrs: {
                            disabled:
                              _vm.user.publicUserId ===
                                _vm.member.publicUserId ||
                              !_vm.isAllowedToUpdate,
                          },
                          on: { "md-selected": _vm.getSelectedRole },
                          model: {
                            value: _vm.member.role,
                            callback: function ($$v) {
                              _vm.$set(_vm.member, "role", $$v)
                            },
                            expression: "member.role",
                          },
                        },
                        _vm._l(_vm.memberRoles, function (memberRole) {
                          return _c(
                            "md-option",
                            {
                              key: memberRole.id,
                              attrs: { value: memberRole.name },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(memberRole.name) +
                                  "\n                            "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "md-layout-item vehicle-box" },
                [
                  _c("label", [_vm._v("Routing Speed:")]),
                  _c(
                    "md-radio",
                    {
                      attrs: {
                        value: "Bike",
                        disabled: !_vm.isAllowedToUpdate,
                      },
                      model: {
                        value: _vm.vehicleType,
                        callback: function ($$v) {
                          _vm.vehicleType = $$v
                        },
                        expression: "vehicleType",
                      },
                    },
                    [_vm._v("Bike")]
                  ),
                  _c(
                    "md-radio",
                    {
                      attrs: { value: "Car", disabled: !_vm.isAllowedToUpdate },
                      model: {
                        value: _vm.vehicleType,
                        callback: function ($$v) {
                          _vm.vehicleType = $$v
                        },
                        expression: "vehicleType",
                      },
                    },
                    [_vm._v("Car")]
                  ),
                  _c(
                    "md-radio",
                    {
                      attrs: {
                        value: "Walk",
                        disabled: !_vm.isAllowedToUpdate,
                      },
                      model: {
                        value: _vm.vehicleType,
                        callback: function ($$v) {
                          _vm.vehicleType = $$v
                        },
                        expression: "vehicleType",
                      },
                    },
                    [_vm._v("Walk")]
                  ),
                  _c(
                    "md-radio",
                    {
                      attrs: {
                        value: "Truck",
                        disabled: !_vm.isAllowedToUpdate,
                      },
                      model: {
                        value: _vm.vehicleType,
                        callback: function ($$v) {
                          _vm.vehicleType = $$v
                        },
                        expression: "vehicleType",
                      },
                    },
                    [_vm._v("Truck")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "information-box" }, [
            _c("div", { staticClass: "md-layout" }, [
              _c(
                "div",
                { staticClass: "md-layout-item" },
                [
                  _c(
                    "form-group",
                    {
                      staticClass: "md-field-split",
                      attrs: {
                        name: "role",
                        label: "Mobile Location Tracking Behaviour",
                      },
                    },
                    [
                      _c("gps-collection-dropdown", {
                        attrs: {
                          selected: _vm.member.gpsDataCollectionRule,
                          disabled: !_vm.isAllowedToUpdate,
                        },
                        on: {
                          selectedOption: _vm.getSelectedTrackingBehaviour,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "md-layout-item md-xsmall-size-100 md-size-25" },
                [
                  _c(
                    "form-group",
                    {
                      staticClass: "timer-field hide-timer-clear-button",
                      attrs: {
                        name: "defaultTripStartTime",
                        label: "Start Time",
                      },
                    },
                    [
                      _c("time-picker", {
                        attrs: {
                          time: _vm.startTime,
                          "all-time-options": false,
                          "clear-none": true,
                          disabled: !_vm.isAllowedToUpdate,
                        },
                        on: { selectedTime: _vm.getStartTime },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "md-layout-item md-xsmall-size-100 md-size-25" },
                [
                  _c(
                    "form-group",
                    {
                      staticClass: "timer-field",
                      attrs: { name: "defaultTripEndTime", label: "End Time" },
                    },
                    [
                      _c("time-picker", {
                        attrs: {
                          time: _vm.endTime,
                          "all-time-options": false,
                          disabled: !_vm.isAllowedToUpdate,
                        },
                        on: { selectedTime: _vm.getEndTime },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "information-box" }, [
            _c("div", { staticClass: "md-layout" }, [
              _c(
                "div",
                { staticClass: "md-layout-item md-xsmall-size-100 md-size-25" },
                [
                  _c(
                    "form-group",
                    {
                      attrs: {
                        name: "defaultStopDurationMinutes",
                        label: "Default Stop Duration (in Minutes)",
                      },
                    },
                    [
                      _c("md-input", {
                        attrs: { type: "number" },
                        model: {
                          value: _vm.member.defaultStopDurationMinutes,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.member,
                              "defaultStopDurationMinutes",
                              _vm._n($$v)
                            )
                          },
                          expression: "member.defaultStopDurationMinutes",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "md-layout-item md-xsmall-size-100 md-size-35" },
                [
                  _c(
                    "form-group",
                    {
                      attrs: {
                        name: "stopDurationMultiplier",
                        label: "Stop Duration Multiplier",
                      },
                    },
                    [
                      _c("md-input", {
                        attrs: { type: "number" },
                        model: {
                          value: _vm.member.stopDurationMultiplier,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.member,
                              "stopDurationMultiplier",
                              _vm._n($$v)
                            )
                          },
                          expression: "member.stopDurationMultiplier",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "information-box" }, [
            _c("div", { staticClass: "md-layout" }, [
              _c(
                "div",
                { staticClass: "md-layout-item" },
                [
                  _c("google-autocomplete", {
                    ref: "startaddress",
                    attrs: {
                      label: "Start Address",
                      id: "startaddress",
                      classname: "form-control autocomplete-input",
                      placeholder: "",
                      disabled: !_vm.isAllowedToUpdate,
                    },
                    on: { placechanged: _vm.handleStartLocationChange },
                    model: {
                      value: _vm.startLocation,
                      callback: function ($$v) {
                        _vm.startLocation = $$v
                      },
                      expression: "startLocation",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "information-box" }, [
            _c("div", { staticClass: "md-layout" }, [
              _c(
                "div",
                { staticClass: "md-layout-item" },
                [
                  _c("google-autocomplete", {
                    ref: "endaddress",
                    attrs: {
                      label: "End Address",
                      id: "endaddress",
                      classname: "form-control autocomplete-input",
                      placeholder: "",
                      disabled: !_vm.isAllowedToUpdate,
                    },
                    on: { placechanged: _vm.handleEndLocationChange },
                    model: {
                      value: _vm.endLocation,
                      callback: function ($$v) {
                        _vm.endLocation = $$v
                      },
                      expression: "endLocation",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "information-box" }, [
            _c("div", { staticClass: "md-layout" }, [
              _c(
                "div",
                { staticClass: "md-layout-item" },
                [
                  _c(
                    "md-field",
                    [
                      _c("label", [_vm._v("Bio")]),
                      _c("md-textarea", {
                        attrs: { disabled: !_vm.isAllowedToUpdate },
                        model: {
                          value: _vm.member.bio,
                          callback: function ($$v) {
                            _vm.$set(_vm.member, "bio", $$v)
                          },
                          expression: "member.bio",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "information-box" }, [
            _c("div", { staticClass: "md-layout" }, [
              _c(
                "div",
                { staticClass: "md-layout-item custom-switch" },
                [
                  _c(
                    "label",
                    { staticClass: "label-text" },
                    [
                      _vm._v(
                        "\n                        Is this user a driver?\n                        "
                      ),
                      _c("md-icon", { staticClass: "icon-info" }, [
                        _vm._v("info"),
                      ]),
                      _c(
                        "md-tooltip",
                        {
                          staticClass: "tooltip-width",
                          attrs: { "md-direction": "right" },
                        },
                        [
                          _vm._v(
                            "\n                            This setting is used to determine whether the user can be assigned stops or shipments.\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("md-switch", {
                    model: {
                      value: _vm.isDriver,
                      callback: function ($$v) {
                        _vm.isDriver = $$v
                      },
                      expression: "isDriver",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "information-box" }, [
            _c("div", { staticClass: "md-layout" }, [
              _c(
                "div",
                { staticClass: "md-layout-item custom-switch" },
                [
                  _c("label", { staticClass: "label-text" }, [
                    _vm._v("Enable Stop/Shipment Offer Notifications"),
                  ]),
                  _c("md-switch", {
                    model: {
                      value: _vm.canReceiveOffers,
                      callback: function ($$v) {
                        _vm.canReceiveOffers = $$v
                      },
                      expression: "canReceiveOffers",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm.member.hasTeamAppPermissions
            ? _c("div", { staticClass: "information-box" }, [
                _c("div", { staticClass: "md-layout" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-75 md-xsmall-size-100 md-size-75",
                    },
                    [
                      _c("h5", { staticClass: "app-title" }, [
                        _vm._v("App Permissions"),
                      ]),
                      _c(
                        "label",
                        {
                          staticClass:
                            "md-layout-item md-size-35 md-form-label",
                        },
                        [_vm._v("Views")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "md-layout-item md-size-100 layout-item",
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "md-checkbox",
                                {
                                  on: { change: _vm.itemScanningChanged },
                                  model: {
                                    value:
                                      _vm.member.appPermissions.views.items,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.member.appPermissions.views,
                                        "items",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "member.appPermissions.views.items",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Item scanning\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "md-checkbox",
                                {
                                  on: { change: _vm.itemChecklistChanged },
                                  model: {
                                    value:
                                      _vm.member.appPermissions.views
                                        .itemChecklist,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.member.appPermissions.views,
                                        "itemChecklist",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "member.appPermissions.views.itemChecklist",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Item checklist\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.member.appPermissions.views
                                      .itemChecklist,
                                  expression:
                                    "member.appPermissions.views.itemChecklist",
                                },
                              ],
                              staticClass: "item-checklist-scanning-container",
                            },
                            [
                              _c(
                                "md-checkbox",
                                {
                                  model: {
                                    value:
                                      _vm.member.appPermissions.views
                                        .itemChecklistScanning,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.member.appPermissions.views,
                                        "itemChecklistScanning",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "member.appPermissions.views.itemChecklistScanning",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                With scanning\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "md-checkbox",
                                {
                                  on: { change: _vm.qrFrequentAddressChanged },
                                  model: {
                                    value:
                                      _vm.member.appPermissions
                                        .qrFrequentAddress,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.member.appPermissions,
                                        "qrFrequentAddress",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "member.appPermissions.qrFrequentAddress",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                QR frequent address\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-75 md-xsmall-size-100 md-size-75",
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "md-layout-item md-size-35 md-form-label",
                        },
                        [_vm._v("Default view")]
                      ),
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-size-65" },
                        [
                          _c(
                            "md-field",
                            [
                              _c(
                                "md-select",
                                {
                                  attrs: { name: "defaultview" },
                                  model: {
                                    value:
                                      _vm.member.appPermissions.views.default,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.member.appPermissions.views,
                                        "default",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "member.appPermissions.views.default",
                                  },
                                },
                                [
                                  _c("md-option", { attrs: { value: "" } }, [
                                    _vm._v("Not Selected"),
                                  ]),
                                  _c(
                                    "md-option",
                                    { attrs: { value: "items" } },
                                    [_vm._v("Item scanning")]
                                  ),
                                  _c(
                                    "md-option",
                                    { attrs: { value: "itemChecklist" } },
                                    [_vm._v("Item checklist")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _vm.isAllowedToUpdate
                ? _c(
                    "md-button",
                    {
                      staticClass: "md-primary pull-right",
                      on: { click: _vm.validateForm },
                    },
                    [_vm._v("\n                Update Profile\n            ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }